import add_data from '../partner/add_data'
import update_data from '../partner/update_data'

const home_index = () => import(/* webpackChunkName: "ehcarts" */ '../home/index')
const vrmeeting_index = () => import(/* webpackChunkName: "ehcarts" */ '../vrmeeting/index');
const help_index = () => import(/* webpackChunkName: "ueditor" */ '../help/index');
const help_group = () => import(/* webpackChunkName: "ueditor" */ '../help/group');
const data_updatelog = () => import(/* webpackChunkName: "ueditor" */ '../setting/data_updatelog');
const basic_notice = () => import(/* webpackChunkName: "ueditor" */ '../setting/basic_notice');
const data_mail = () => import(/* webpackChunkName: "ueditor" */ '../setting/data_mail');
const basic_pico = () => import(/* webpackChunkName: "ueditor" */ '../setting/basic_pico');
const wxcdy_menu = () => import(/* webpackChunkName: "ueditor" */ '../setting/wxcdy_menu');
const basic_chuang = () => import(/* webpackChunkName: "ueditor" */ '../setting/basic_chuang');
const basic_inform = () => import(/* webpackChunkName: "ueditor" */ '../setting/basic_inform');
const renewal_setting = () => import(/* webpackChunkName: "ueditor" */ '../setting/renewal_setting');
const server_setting = () => import(/* webpackChunkName: "ueditor" */ '../setting/server_setting');
const reset = () => import(/* webpackChunkName: "ueditor" */ '../setting/reset');

const summary_login = () => import(/* webpackChunkName: "summary_login" */ '../layout/login');
//总后台路由切割
const summary_main = () => import(/* webpackChunkName: "summary" */ '../layout/main');
const summary_partner = () => import(/* webpackChunkName: "summary" */ '../partner/index');
const summary_blacklist = () => import(/* webpackChunkName: "summary" */ '../partner/blacklist');
const summary_agentgroup = () => import(/* webpackChunkName: "summary" */ '../partner/agentgroup');
const summary_agentauthinfo = () => import(/* webpackChunkName: "summary" */ '../partner/agentauthinfo');
const summary_add_authinfo = () => import(/* webpackChunkName: "summary" */ '../partner/add_authinfo');
const summary_add_group = () => import(/* webpackChunkName: "summary" */ '../partner/add_group');
const summary_terminal_index = () => import(/* webpackChunkName: "summary" */ '../terminal/index');
const summary_terminal_zdblack = () => import(/* webpackChunkName: "summary" */ '../terminal/zdblack');
const summary_terminal_audit = () => import(/* webpackChunkName: "summary" */ '../terminal/audit');
const summary_data_audit = () => import(/* webpackChunkName: "summary" */ '../terminal/data_audit');
const summary_works_index = () => import(/* webpackChunkName: "summary" */ '../works/index');
const summary_works_third = () => import(/* webpackChunkName: "summary" */ '../works/third');
const summary_works_pixel = () => import(/* webpackChunkName: "summary" */ '../works/pixel');
const summary_works_video = () => import(/* webpackChunkName: "summary" */ '../works/video');
const summary_works_menu = () => import(/* webpackChunkName: "summary" */ '../works/menu');
const summary_works_yun = () => import(/* webpackChunkName: "summary" */ '../works/yun');
const summary_works_vrlive = () => import(/* webpackChunkName: "summary" */ '../works/vrlive');
const summary_works_travel = () => import(/* webpackChunkName: "summary" */ '../works/travel');
const summary_works_avatar = () => import(/* webpackChunkName: "summary" */ '../works/avatar');
const summary_works_contrast = () => import(/* webpackChunkName: "summary" */ '../works/contrast');
const summary_works_mall = () => import(/* webpackChunkName: "summary" */ '../works/mall');
const summary_live_index = () => import(/* webpackChunkName: "summary" */ '../live/index');
const summary_live_favouredpolicy = () => import(/* webpackChunkName: "summary" */ '../live/favouredpolicy');
const summary_live_releasetime = () => import(/* webpackChunkName: "summary" */ '../live/releasetime');
const summary_live_agent_log = () => import(/* webpackChunkName: "summary" */ '../live/agentlog');
const summary_offline_log = () => import(/* webpackChunkName: "summary" */ '../orderManage/offlinelog');
const summary_offlinelog_domain_log = () => import(/* webpackChunkName: "summary" */ '../orderManage/offlinelog_domain');
const summary_live_AiAvatar_log = () => import(/* webpackChunkName: "summary" */ '../orderManage/AiAvatarlog');
const summary_live_huoke = () => import(/* webpackChunkName: "summary" */ '../orderManage/huoke');
const summary_regscene = () => import(/* webpackChunkName: "summary" */ '../regscene/index');
const summary_train = () => import(/* webpackChunkName: "summary" */ '../train/index');
const summary_feedback = () => import(/* webpackChunkName: "summary" */ '../feedback/index');
const summary_basic_poster = () => import(/* webpackChunkName: "summary" */ '../setting/basic_poster');
const summary_list_admin = () => import(/* webpackChunkName: "summary" */ '../setting/list_admin');
const summary_list_group = () => import(/* webpackChunkName: "summary" */ '../setting/list_group');
const summary_data_worklog = () => import(/* webpackChunkName: "summary" */ '../setting/data_worklog');
const summary_data_sumlog = () => import(/* webpackChunkName: "summary" */ '../setting/data_sumlog');
const tripartite = () => import(/* webpackChunkName: "summary" */ '../setting/tripartite')
const summary_list_group_add = () => import(/* webpackChunkName: "summary" */ '../setting/list_group_add');
const summary_setting_power = () => import(/* webpackChunkName: "summary" */ '../setting/setting_power');
const summary_setting_agent = () => import(/* webpackChunkName: "summary" */ '../setting/setting_agent');
const summary_setting_member = () => import(/* webpackChunkName: "summary" */ '../setting/setting_member');
const summary_setting_mailbind = () => import(/* webpackChunkName: "summary" */ '../setting/setting_mailbind');
const summary_setting_pay = () => import(/* webpackChunkName: "summary" */ '../setting/setting_pay');
const summary_setting_IPlimit = () => import(/* webpackChunkName: "summary" */ '../setting/setting_IPlimit');

const summary_audit_trade = () => import(/* webpackChunkName: "summary" */ '../setting/audit_trade');
const summary_audit_360 = () => import(/* webpackChunkName: "summary" */ '../setting/audit_360');
const summary_audit_model = () => import(/* webpackChunkName: "summary" */ '../setting/audit_model');

// 订单管理
const summary_order_live = () => import('../orderManage/index');  // 全景直播
const summary_order_digital = () => import('../orderManage/aiDigital');  // ai数字人
const summary_renewal_order = () => import('../orderManage/renewalOrder');  // 合作商续费

var summary_router = [
    {
        name: "/summary/login",
        path: "/summary/login",//合作商列表√
        component: summary_login,
        meta: {title: "管理后台登录"},
    }, {
        path: '/summary',
        name: '/summary',  //合作商管理
        component: summary_main,
        redirect: '/summary/login',
        children: [{
            name: "/summary/partner",
            path: "/summary/partner",//合作商列表√
            component: summary_partner,
            meta: {title: "合作商列表"},
        }, {
            name: "/summary/partner/blacklist",
            path: "/summary/partner/blacklist",//合作商黑名单√
            component: summary_blacklist,
            meta: {title: "合作商黑名单"},
        }, {
            name: "/summary/partner/agentgroup",
            path: "/summary/partner/agentgroup",//合作版本管理√
            component: summary_agentgroup,
            meta: {title: "合作商版本"},
        }, {
            name: "/summary/partner/agentauthinfo",
            path: "/summary/partner/agentauthinfo",//合作版本管理√
            component: summary_agentauthinfo,
            meta: {title: "合作商权限"},
        }, {
            name: "/summary/partner/add_data",
            path: "/summary/partner/add_data",//添加合作商√
            component: add_data,
            meta: {title: "添加合作商"},
        }, {
            name: "/summary/partner/update_data",
            path: "/summary/partner/update_data",//编辑合作商√
            component: update_data,
            meta: {title: "编辑合作商"},
        }, {
            name: "/summary/partner/add_authinfo",
            path: "/summary/partner/add_authinfo",//合作商权限√
            component: summary_add_authinfo,
            meta: {title: "合作商权限"},
        }, {
            name: "/summary/partner/add_group",
            path: "/summary/partner/add_group",//合作商版本√
            component: summary_add_group,
            meta: {title: "合作商版本"},
        }
        ],
    },

    {
        path: '/summary/terminal_body',
        name: '/summary/terminal_body',//终端用户
        component: summary_main,
        redirect: '/summary/terminal',
        children: [{
            path: '/summary/terminal',
            name: '/summary/terminal',//终端列表√
            component: summary_terminal_index,
            meta: {title: "终端列表"},
        }, {
            path: '/summary/terminal/zdblack',
            name: '/summary/terminal/zdblack',//终端黑名单√
            component: summary_terminal_zdblack,
            meta: {title: "终端黑名单"},
        }, {
            path: '/summary/terminal/audit',
            name: '/summary/terminal/audit',//终端审核√
            component: summary_terminal_audit,
            meta: {title: "终端审核"},
        }, {
            name: "/summary/terminal/data_audit",
            path: "/summary/terminal/data_audit",//添加用户组√
            component: summary_data_audit,
            meta: {title: "添加用户组"},
        },
        ]
    },
    {
        path: '/summary/works_body',
        name: '/summary/works_body',//作品管理
        component: summary_main,
        redirect: '/summary/works',
        children: [{
            path: '/summary/works',
            name: '/summary/works',//作品列表√
            component: summary_works_index,
            meta: {title: "作品列表"},
        }, {
            path: '/summary/works/third',
            name: '/summary/works/third',//第三方接入列表
            component: summary_works_third,
            meta: {title: "第三方接入列表"},
        }, {
            path: '/summary/works/pixel',
            name: '/summary/works/pixel',//大像素列表
            component: summary_works_pixel,
            meta: {title: "大像素列表"},
        }, {
            path: '/summary/works/video',
            name: '/summary/works/video',//动态交互列表
            component: summary_works_video,
            meta: {title: "动态交互列表"},
        }, {
            path: '/summary/works/menu',
            name: '/summary/works/menu',//酷客导航列表
            component: summary_works_menu,
            meta: {title: "酷客导航列表"},
        }, {
            path: '/summary/works/yun',
            name: '/summary/works/yun',//云游作品列表
            component: summary_works_yun,
            meta: {title: "云游作品列表"},
        }, {
            path: '/summary/works/vrlive',
            name: '/summary/works/vrlive',//vr直播列表
            component: summary_works_vrlive,
            meta: {title: "VR直播列表"},
        }, {
            path: '/summary/works/travel',
            name: '/summary/works/travel',//云游展位列表
            component: summary_works_travel,
            meta: {title: "云游展位列表"},
        }, {
            path: '/summary/works/avatar',
            name: '/summary/works/avatar',//云游展位列表
            component: summary_works_avatar,
            meta: {title: "AI数字人展位列表"},
        }, {
            path: '/summary/works/contrast',
            name: '/summary/works/contrast',//动态交互列表
            component: summary_works_contrast,
            meta: {title: "对比列表"},
        }, {
            path: '/summary/works/mall',
            name: '/summary/works/mall',//动态交互列表
            component: summary_works_mall,
            meta: {title: "商城列表"},
        }, {
            name: "/summary/setting/audit_360",
            path: "/summary/setting/audit_360",//广告审核管理--360环物审核
            component: summary_audit_360,
            meta: {title: "360环物审核"},
        }, {
            name: "/summary/setting/audit_model",
            path: "/summary/setting/audit_model",//广告审核管理--360环物审核
            component: summary_audit_model,
            meta: {title: "模型环物审核"},
        }, {
            name: "/summary/setting/audit_book",
            path: "/summary/setting/audit_book",//广告审核管理--360环物审核
            component: resolve => require(['../setting/audit_book'], resolve),
            meta: {title: "手册环物审核"},
        }
        ]
    },
    {
        path: '/summary/home_body',
        name: '/summary/home_body',//数据信息
        component: summary_main,
        redirect: '/summary/home',
        children: [{
            path: '/summary/home',
            name: '/summary/home',//数据信息
            component: home_index,
            meta: {title: "数据信息"},
        }, {
            path: '/summary/vrmeeting',
            name: '/summary/vrmeeting',//数据信息
            component: vrmeeting_index,
            meta: {title: "VR会议"},
        }, {
             path: '/summary/home/agentlog',
             name: '/summary/home/agentlog',//数据信息
             component: summary_live_agent_log,
             meta: {title: "直播时长"},
            },{
             path: '/summary/orderManage/AiAvatarlog',
             name: '/summary/orderManage/AiAvatarlog',//数据信息
             component: summary_live_AiAvatar_log,
            meta: {title: "数字人时长"},
        },{
            path: '/summary/orderManage/huoke',
            name: '/summary/orderManage/huoke',//数据信息
            component: summary_live_huoke,
           meta: {title: "客户资源"},
       },{
             path: '/summary/orderManage/offlinelog',
             name: '/summary/orderManage/offlinelog',//数据信息
             component: summary_offline_log,
            meta: {title: "离线包"},
        },{
             path: '/summary/orderManage/domainlog',
             name: '/summary/orderManage/domainlog',//数据信息
             component: summary_offlinelog_domain_log,
            meta: {title: "离线包"},
        },
        ]
    },
    {
        path: '/summary/ordermanage',
        name: '/summary/ordermanage',
        component: summary_main,
        redirect: '/summary/ordermanage',
        children: [{
            path: '/summary/ordermanage',
            name: '/summary/ordermanage',
            component: summary_live_releasetime,
            meta: {title: '全景直播'}
        }, {
            path: '/summary/ordermanage/aiDigital',
            name: '/summary/ordermanage/aiDigital',
            component: summary_order_digital,
            meta: {title: 'AI数字人'}
        }, {
            path: '/summary/ordermanage/renewalOrder',
            name: '/summary/ordermanage/renewalOrder',
            component: summary_renewal_order,
            meta: {title: '合作商续费'}
        }]
    },
    {
        path: '/summary/livemanagement',
        name: '/summary/livemanagement',//直播管理
        component: summary_main,
        redirect: '/summary/live',
        children: [{
            path: '/summary/live',
            name: '/summary/live',//直播时间管理√
            component: summary_live_index,
            meta: {title: "直播时间管理"},
        }, {
            path: '/summary/live/favouredpolicy',
            name: '/summary/live/favouredpolicy',//优惠政策√
            component: summary_live_favouredpolicy,
            meta: {title: "优惠政策"},
        }, {
            path: '/summary/live/releasetime',
            name: '/summary/live/releasetime',//发放记录√
            component: summary_live_releasetime,
            meta: {title: "发放记录"},
        }]
    },
    {
        path: '/summary/regscene_body',
        name: '/summary/regscene_body',//注册中心
        component: summary_main,
        redirect: '/summary/regscene',
        children: [{
            path: '/summary/regscene',
            name: '/summary/regscene',//注册信息列表√
            component: summary_regscene,
            meta: {title: "注册信息列表"},
        }]
    },
    {
        path: '/summary/help_body',
        name: '/summary/help_body',//帮助与教程
        component: summary_main,
        redirect: '/summary/help',
        children: [{
            path: '/summary/help',
            name: '/summary/help',//帮助中心首页√
            component: help_index,
            meta: {title: "帮助中心"},
        }, {
            path: '/summary/help/group',
            name: '/summary/help/group',//分类管理√
            component: help_group,
            meta: {title: "使用教程"},
        }]
    },
    {
        path: '/summary/Training',
        name: '/summary/Training',//培训资料
        component: summary_main,
        redirect: '/summary/train',
        children: [{
            path: '/summary/train',
            name: '/summary/train',//资料列表√
            component: summary_train,
            meta: {title: "资料列表"},
        }]
    },

    {
        path: '/summary/Feedback',
        name: '/summary/Feedback',//意见反馈
        component: summary_main,
        redirect: '/summary/feedback',
        children: [{
            path: '/summary/feedback',
            name: '/summary/feedback',//问题答疑√
            component: summary_feedback,
            meta: {title: "反馈列表"},
        }]
    },
    {
        path: '/summary/setting',
        name: '/summary/setting',//系统设置
        component: summary_main,
        redirect: '/summary/setting/basic_notice',
        children: [{
            name: "/summary/setting/basic_notice",
            path: "/summary/setting/basic_notice",//基础设置--法律声明√
            component: basic_notice,
            meta: {title: "法律声明"},
        },
            {
                name: "/summary/setting/basic_inform",
                path: "/summary/setting/basic_inform",//基础设置--入驻须知√
                component: basic_inform,
                meta: {title: "入驻须知"},
            },
            {
                name: "/summary/setting/server_setting",
                path: "/summary/setting/server_setting",//续费设置
                component: server_setting,
                meta: {title: "服务器设置"},
            },
            {
                name: "/summary/setting/renewal_setting",
                path: "/summary/setting/renewal_setting",//续费设置
                component: renewal_setting,
                meta: {title: "续费设置"},
            },
            {
                name: "/summary/setting/basic_pico",
                path: "/summary/setting/basic_pico",//基础设置--入驻须知√
                component: basic_pico,
                meta: {title: "Pico眼镜教程"},
            },
            {
                name: "/summary/setting/wxcdy_menu",
                path: "/summary/setting/wxcdy_menu",//基础设置--入驻须知√
                component: wxcdy_menu,
                meta: {title: "微信公众号"},
            },
            {
                name: "/summary/setting/basic_chuang",
                path: "/summary/setting/basic_chuang",//基础设置--入驻须知√
                component: basic_chuang,
                meta: {title: "创维眼镜教程"},
            },
            {
                name: "/summary/setting/reset",
                path: "/summary/setting/reset",
                component: reset,
                meta: {title: "清空缓存"},
            },
            {
                name: "/summary/setting/basic_poster",
                path: "/summary/setting/basic_poster",//基础设置--广告设置√
                component: summary_basic_poster,
                meta: {title: "广告设置"},
            },
            {
                name: "/summary/setting/list_admin",
                path: "/summary/setting/list_admin",//管理员设置--管理员账号√
                component: summary_list_admin,
                meta: {title: "管理员账号"},
            },
            {
                name: "/summary/setting/list_group",
                path: "/summary/setting/list_group",//管理员设置--用户组管理√
                component: summary_list_group,
                meta: {title: "管理员权限管理"},
            },
            {
                name: "/summary/setting/data_mail",
                path: "/summary/setting/data_mail",//平台信息管理--站内信息管理
                component: data_mail,
                meta: {title: "消息设置"},
            },
            {
                name: "/summary/setting/data_updatelog",
                path: "/summary/setting/data_updatelog",//平台信息管理--更新日志
                component: data_updatelog,
                meta: {title: "更新日志"},
            },
            {
                name: "/summary/setting/data_worklog",
                path: "/summary/setting/data_worklog",//平台信息管理--操作日志
                component: summary_data_worklog,
                meta: {title: "操作日志"},
            },
            {
                name: "/summary/setting/data_sumlog",
                path: "/summary/setting/data_sumlog",//平台信息管理--综合日志
                component: summary_data_sumlog,
                meta: {title: "综合日志"},
            },
            {
                name: "/summary/setting/tripartite",
                path: "/summary/setting/tripartite",//平台信息管理--三方设置
                component: tripartite,
                meta: {title: "如视设备"},
            },
            {
                name: "/summary/setting/offline_log",
                path: "/summary/setting/offline_log",//平台信息管理--综合日志
                component: summary_offline_log,
                meta: {title: "域名购买记录"},
            },
            {
                name: "/summary/setting/list_group/add",
                path: "/summary/setting/list_group/add",//平台信息管理--添加用户组
                component: summary_list_group_add,
                meta: {title: "添加用户组"},
            },
            {
                name: "/summary/setting/setting_power",
                path: "/summary/setting/setting_power",//平台设置--总权限设置
                component: summary_setting_power,
                meta: {title: "总权限设置"},
            },
            {
                name: "/summary/setting/setting_agent",
                path: "/summary/setting/setting_agent",//平台设置--合作商权限设置
                component: summary_setting_agent,
                meta: {title: "合作商权限设置"},
            },
            {
                name: "/summary/setting/setting_member",
                path: "/summary/setting/setting_member",//平台设置--终端权限设置
                component: summary_setting_member,
                meta: {title: "终端权限设置"},
            },
            {
                name: "/summary/setting/setting_mailbind",
                path: "/summary/setting/setting_mailbind",//平台设置--邮箱绑定
                component: summary_setting_mailbind,
                meta: {title: "邮箱绑定"},
            },
            {
                name: "/summary/setting/setting_pay",
                path: "/summary/setting/setting_pay",//平台设置--支付参数设置
                component: summary_setting_pay,
                meta: {title: "支付参数设置"},
            },
            {
                name: "/summary/setting/setting_IPlimit",
                path: "/summary/setting/setting_IPlimit",//平台设置--IP限定
                component: summary_setting_IPlimit,
                meta: {title: "IP限定"},
            },
            {
                name: "/summary/setting/audit_trade",
                path: "/summary/setting/audit_trade",//广告审核管理--行业展位审核
                component: summary_audit_trade,
                meta: {title: "行业展位审核"},
            },
            {
                name: "/summary/setting/audit_360",
                path: "/summary/setting/audit_360",//广告审核管理--360环物审核
                component: summary_audit_360,
                meta: {title: "360环物审核"},
            }, {
                name: "/summary/setting/audit_model",
                path: "/summary/setting/audit_model",//广告审核管理--360环物审核
                component: summary_audit_model,
                meta: {title: "模型环物审核"},
            }, {
                name: "/summary/setting/audit_book",
                path: "/summary/setting/audit_book",//广告审核管理--360环物审核
                component: resolve => require(['../setting/audit_book'], resolve),
                meta: {title: "手册环物审核"},
            },
        ]
    },
];
export {
    summary_router
}



// WEBPACK FOOTER //
// ./src/summary/router/index.js